import { DefaultTheme } from 'styled-components';

export type SpacingKey =
  | 0
  | 2
  | 4
  | 8
  | 12
  | 16
  | 20
  | 24
  | 32
  | 40
  | 48
  | 56
  | 64;

const spacingMap: Record<SpacingKey, number> = {
  0: 0,
  2: 0.125,
  4: 0.25,
  8: 0.5,
  12: 0.75,
  16: 1,
  20: 1.25,
  24: 1.5,
  32: 2,
  40: 2.5,
  48: 3,
  56: 3.5,
  64: 4,
};

const spacing: DefaultTheme['spacing'] = (s: SpacingKey) =>
  `${spacingMap[s || 0]}rem`;

export default spacing;
